<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I had an error when trying to pay</h1>

			<email-form
					subject="I am getting an error when trying to pay"
					:body="email_body"
					on-success-url="/help?#/submitted"
					:emailRequired="!this.$globs['customer_info'] || !this.$globs['customer_info']['email']"
					:fullNameRequired="!this.$globs['customer_info'] || !this.$globs['customer_info']['fullname']"
					edit-body
					must-edit
					attach-screenshot
					destination-key="ge"
					:payload="{has_attachment: true}"
			></email-form>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';
	import EmailForm from './../components/EmailForm';

	export default {
		name: "ErrorWhenPay",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		computed: {
			email_body() {
				const school = this.$globs['institute_info'] && this.$globs['institute_info']['name'] ? this.$globs['institute_info']['name'] : '<School>';

				return `I am trying to order but I am getting an error. I go to ${school}.\n`
					+ "The error is:\n\n\n\n\n\nThanks\n"
			}
		},
	}
</script>

<style scoped>

</style>